@if (timeLapsed) {
  <span [ngClass]="classNames"
        [title]="formattedTimeLapsed">{{timeLapsed}}</span>
}
